import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import {
  CareOfAddressValidator,
  EmailAddressValidator,
  GridAreaIdValidator,
  MaxValidator,
  MinValidator,
  OrganisationNumberValidator,
  PasswordValidator,
  PersonalNumberValidator,
  PhoneNumberValidator,
  PostalCodeValidator,
  PostalTownValidator,
  PremiseIdValidator,
  StreetNameValidator,
} from "./validators.directive";

@NgModule({
  declarations: [
    EmailAddressValidator,
    GridAreaIdValidator,
    MaxValidator,
    MinValidator,
    OrganisationNumberValidator,
    PasswordValidator,
    PersonalNumberValidator,
    PhoneNumberValidator,
    PremiseIdValidator,
    PostalCodeValidator,
    StreetNameValidator,
    CareOfAddressValidator,
    PostalTownValidator,
  ],
  imports: [CommonModule],
  exports: [
    EmailAddressValidator,
    GridAreaIdValidator,
    MaxValidator,
    MinValidator,
    OrganisationNumberValidator,
    PasswordValidator,
    PersonalNumberValidator,
    PhoneNumberValidator,
    PremiseIdValidator,
    PostalCodeValidator,
    StreetNameValidator,
    CareOfAddressValidator,
    PostalTownValidator,
  ],
})
export class ValidatorsModule {}
